import { EditMode } from "@/types/editMode";
import { ModelCommandResponse } from "@api/apiClient";
import i18n from "@i18n/i18n";
import { Button, Container, Grid, Typography } from "@mui/material";
import { observer } from "mobx-react";
import { useState } from "react";
import NonModelledElementDialog from "./NonModelledElementDialog";
import NonModelledElementsGrid from "./NonModelledElementsGrid";

const NonModelledElementsPage = observer(() => {
  const [mode, setMode] = useState<EditMode>(EditMode.Add);
  const [data, setData] = useState<ModelCommandResponse>({ name: "Basic" } as ModelCommandResponse);
  const [openRebarDialog, setOpenRebarDialog] = useState<boolean>(false);

  function handleviewRebar() {
    setOpenRebarDialog(true);
    setMode(EditMode.Add);
  }

  function handleviewnonElementConfig(commadObje: ModelCommandResponse) {
    setMode(EditMode.Edit);
    setData(commadObje);
    setOpenRebarDialog(true);
  }

  const handleCloseRebarSettings = () => {
    setOpenRebarDialog(false);
  };

  return (
    <>
      <Container maxWidth={false} sx={{ height: "100%" }}>
        <Grid mt={2} container spacing={2} sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
          <Grid size={12} sx={{ display: "flex", flexGrow: 0 }}>
            <Typography variant="h6" fontWeight="bold">
              {i18n.t("non-model-element.header")}
            </Typography>
          </Grid>
          <Grid size={12} sx={{ display: "flex", flexGrow: 0 }}>
            <Button variant="outlined" onClick={() => handleviewRebar()}>
              {i18n.t("non-model-element.add-Configuration-button")}
            </Button>
          </Grid>
          <Grid size={12} sx={{ display: "flex", flexGrow: 1, flexDirection: "column", position: "relative" }}>
            <NonModelledElementsGrid onEdit={(commandObject: ModelCommandResponse) => handleviewnonElementConfig(commandObject)} />
          </Grid>
        </Grid>
      </Container>
      {openRebarDialog && (
        <NonModelledElementDialog
          open={openRebarDialog}
          editMode={mode}
          onClose={() => handleCloseRebarSettings()}
          filteredElementConfigurationId={""}
          data={data}
        ></NonModelledElementDialog>
      )}
    </>
  );
});

export default NonModelledElementsPage;
